/**
 * https://developer.chrome.com/docs/lighthouse/performance/uses-rel-preconnect/?utm_source=lighthouse&utm_medium=cli
 * https://developer.mozilla.org/en-US/docs/Web/Performance/dns-prefetch
 */

import { FunctionComponent, memo } from 'react';

/**
 * Packages
 */
import {
  DnsPrefetch,
  Prefetch as PrefetchComponent
} from '@astrumu/ui-library';

const thirdPartyServices = {
  hotjar: 'https://static.hotjar.com',
  gravatar: 'https://s.gravatar.com',
  amplitude: 'https://api.amplitude.com',
  datadog: 'https://rum.browser-intake-datadoghq.com'
} as const;

interface Props {
  auth0Domain: string;
}

export const Prefetch: FunctionComponent<Props> = memo(({ auth0Domain }) => (
  <PrefetchComponent>
    <DnsPrefetch href={auth0Domain} />

    {Object.keys(thirdPartyServices).map(service => (
      <DnsPrefetch key={service} href={thirdPartyServices[service]} />
    ))}
  </PrefetchComponent>
));
